<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Načini plaćanja</h2>
            <div>

              <p><strong>Za privatne kupce:</strong></p>
              <ol>
                <li>Plaćanje gotovinom po primitku po&scaron;iljke - pouzećem:</li>
              </ol>
              <p>Opcija plaćanja pouzećem vam omogućava da iznos narudžbe podmirite prilikom same dostave na
                navedenu adresu, tek kada robu vidite pred sobom. Plaćanje pouzećem se vr&scaron;i isključivo u
                gotovini, dostavljaču prilikom same isporuke na navedenu adresu. U slučaju da primatelj nije u
                mogućnosti zaprimiti po&scaron;iljku na definiranoj dostavnoj adresi u trenutku dostave,
                dostavljač ostavlja obavijest o prispijeću po&scaron;iljke.</p>
              <ol start="2">
                <li>Jednokratno plaćanje karticama:</li>
              </ol>
              <ul>
                <li>VISA, MasterCard i Maestro</li>
              </ul>
              <p>Zavr&scaron;avanje narudžbe poduzeću Eurosan d.o.o. daje ovlast da tereti Va&scaron; račun za
                plaćanja napravljena u eurosan.ba Internet Trgovini kreditnom ili debitnom karticom. Plaćanje će
                se izvr&scaron;iti čim zavr&scaron;ite narudžbu. Kako biste izbjegli ka&scaron;njenja u obradi
                Va&scaron;e narudžbe, molimo Vas da se pobrinete da su Va&scaron;e ime, broj kartice, datum
                isteka i sigurnosni kod ispravno uneseni, kao &scaron;to je prikazano na Va&scaron;oj kartici.
              </p>
              <p>Sigurnosni kod (CVV) čine tri znamenke ispisane na vrhu polja za potpis na poleđini Va&scaron;e
                MasterCard, Maestro ili VISA kartice.</p>
              <p>U slučaju bilo kakvih pitanja ili pote&scaron;koća s Va&scaron;om narudžbom, molimo Vas da
                nazovete na&scaron; tim za podr&scaron;ku korisnicima na tel. 080 080 080&nbsp; pon &ndash; pet,
                08:00 &ndash; 16:00 h ili putem mail-a na <a href="mailto:webshop@eurosan.ba">webshop@eurosan.ba</a></p>
              <p><strong>Za poslovne kupce:</strong></p>
              <ol>
                <li>Plaćanje gotovinom</li>
              </ol>
              <p>Opcija plaćanja pouzećem vam omogućava da iznos narudžbe podmirite prilikom same dostave na
                navedenu adresu, tek kada robu vidite pred sobom. Plaćanje pouzećem se vr&scaron;i isključivo u
                gotovini, dostavljaču prilikom same isporuke na navedenu adresu. &nbsp;Potpuna kupoprodajna
                cijena + tro&scaron;kovi dostave navedeni su u narudžbi i vrijede ako nije drugačije dogovoreno.
                Račun je u prilogu isporučene robe. U slučaju da primatelj nije u mogućnosti zaprimiti
                po&scaron;iljku na definiranoj dostavnoj adresi u trenutku dostave, dostavljač ostavlja
                obavijest o prispijeću po&scaron;iljke.</p>
              <ol start="2">
                <li>Plaćanje po predračunu<br /> Kod izbora ovog načina plaćanja, na svoju e-mail adresu ćete
                  dobiti predračun sa svim podacima potrebnim za uplatu, uključujući broj bankovnog računa na
                  koji trebate uplatiti vrijednost narudžbe. Uplatu potom možete izvr&scaron;iti
                  kori&scaron;tenjem internet bankarstva ili načinom na koji inače plaćate svoje račune -
                  putem banke, po&scaron;te, ili sl. Po zaprimljenoj uplati, poslat ćemo vam naručene
                  proizvode. Rok za uplatu na predračunu je 3 dana od dostavljene ponude od strane ponuđača.
                  Nakon 3 dana rezervacija odabranih proizvoda bit će poni&scaron;tena.</li><br />
              </ol>

                <ol>
                  <li>Virmansko plaćanje</li>
                </ol>
                <p>U dogovoru sa poduzećem Eurosan d.o.o., poslovni kupac može dobiti odgodu plaćanja u određenom
                  vremenskom periodu. Svi detalji ovog načina plaćanja se dogovaraju direktno s poduzećem Eurosan
                  d.o.o., a mogućnosti odgode ovise od kupca do kupca.</p>

                <h2 class="subtitle">Dostava</h2>
                <p><strong>Za poslovne kupce:</strong></p>
                <ol>
                  <li>Eurosan dostava</li>
                </ol>
                <p>Poslovni kupci mogu odabrati besplatnu Eurosan dostavu. Vrijeme isporuke je unutar 7 dana.</p>
                <ol start="2">
                  <li>Dostava brzom po&scaron;tom</li>
                </ol>
                <p>Ukoliko odaberete brzu po&scaron;tu, po&scaron;tarina ovisi o težini proizvoda koje treba
                  dostaviti. Vrijeme isporuke je 24-48 sati, osim ako Eurosan nema na zalihi artikl, o čemu ćete
                  biti obavije&scaron;teni na vrijeme.</p>
                <ol start="3">
                  <li>Osobno preuzimanje</li>
                </ol>
                <p>Osobno preuzimanje u poslovnici je moguće na sljedećim adresama:</p>
                <ol>
                  <li>Mostar</li>
                </ol>
                <p>Eurosan d.o.o. Mostar<br /> Bi&scaron;će polje bb, 88000 Mostar<br /> 080 080 080 <br /> Radno
                  vrijeme: ponedjeljak &ndash; petak 8:00 &ndash; 16:00</p>
                <ol start="2">
                  <li>Sarajevo</li>
                </ol>
                <p>Ecotime d.o.o. Sarajevo<br /> Lužansko polje 7, 71210 Sarajevo<br /> 033 765 075<br /> Radno
                  vrijeme:<br /> Ponedjeljak &ndash; petak 8:00 &ndash; 16:00</p>
                <ol start="3">
                  <li>Banja Luka</li>
                </ol>
                <p>Eurosan d.o.o. Banja Luka<br /> Jovana Bijelića, 78000 Banja Luka<br /> 051 456 652<br /> Radno
                  vrijeme:<br /> Ponedjeljak &ndash; petak 8:00 &ndash; 16:00<br /> Subota 9:00 &ndash; 13:00</p>
                <p><strong>Za privatne kupce:</strong></p>
                <ol>
                  <li>Brza po&scaron;ta</li>
                </ol>
                <p>Ukoliko odaberete brzu po&scaron;tu, vrijeme isporuke je 24-48 sati,
                  osim ako Eurosan nema na
                  zalihi artikl, o čemu ćete biti obavije&scaron;teni na vrijeme.</p>
                <ol start="2">
                  <li>Osobno preuzimanje</li>
                </ol>
                <p>Osobno preuzimanje u poslovnici je moguće na sljedećim adresama:</p>
                <ol>
                  <li>Mostar</li>
                </ol>
                <p>Eurosan d.o.o. Mostar<br /> Bi&scaron;će polje bb, 88000 Mostar<br />
                  080 080 080 <br /> Radno
                  vrijeme: ponedjeljak &ndash; petak 8:00 &ndash; 16:00</p>
                <ol start="2">
                  <li>Sarajevo</li>
                </ol>
                <p>Ecotime d.o.o. Sarajevo<br /> Lužansko polje 7, 71210 Sarajevo<br />
                  033 765 075<br /> Radno
                  vrijeme: Ponedjeljak &ndash; petak 8:00 &ndash; 16:00<br /> </p>
                <ol start="3">
                  <li>Banja Luka</li>
                </ol>
                <p>Eurosan d.o.o. Banja Luka<br /> Jovana Bijelića, 78000 Banja Luka<br />
                  051 456 652<br /> Radno
                  vrijeme:<br /> Ponedjeljak &ndash; petak 8:00 &ndash; 16:00<br />
                  Subota 9:00 &ndash; 13:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'Complaints',
  mixins: [translations],
};
</script>
